import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Select, Row, Col, DatePicker, Button, TimePicker, message } from 'antd';
import moment from 'moment';
import { getTransactions } from '../actions/actions';
import 'antd/dist/antd.css';

class Search extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dateFormat: 'YYYY-MM-DD',
            timeFormat: 'HH:mm',
            startValue: null,
            endValue: null,
            endOpen: false,
            startTime: null,
            endTime: null,
            searchType: 'Search by Customer Email',
            searchParameter: '',
            transactionStatus: '',
            searchFlag: 'customerEmail',
            pageNo: 1,
            pageSize: 20
        }

        this.onSearchParmeterChange = this.onSearchParmeterChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.onStartTimeChange = this.onStartTimeChange.bind(this);
        this.onEndTimeChange = this.onEndTimeChange.bind(this);
        this.failAction = this.failAction.bind(this);
    }

    onSearchParmeterChange(e) {
        this.setState({
            searchParameter: e.target.value
        })
    }

    disabledStartDate = startValue => {
        const endValue = this.state.endValue;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = endValue => {
        const startValue = this.state.startValue;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    };

    onStartChange = value => {
        this.onChange('startValue', value);
    };

    onEndChange = value => {
        this.onChange('endValue', value);
    };


    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handleEndOpenChange = open => {
        this.setState({ endOpen: open });
    };

    onStartTimeChange(time) {
        this.setState({
            startTime: time,
        });
    }

    onEndTimeChange(time) {
        this.setState({
            endTime: time,
        });
    }

    handleChange(value) {
        this.setState({
            searchType: `Search By ${value}`,
            searchFlag: (value === 'Customer Email') ? 'customerEmail' : (value === 'Transaction Reference') ? 'transactionReference' : (value === 'Customer Id') ? 'customerId' : (value === 'Payment Reference') ? 'paymentReference' : ''
        });
    }

    handleStatusChange(value) {
        this.setState({
            transactionStatus: value
        });
    }

    failAction() {
        message.error("Error processing request at the moment, please try again");
    }

    onSearch() {
        const { startValue, endValue, searchParameter, transactionStatus, searchFlag, startTime, endTime, dateFormat, timeFormat } = this.state

        const payload = {
            data: {
                transactionReference: searchFlag === 'transactionReference' ? searchParameter.trim() : '',
                customerEmail: searchFlag === 'customerEmail' ? searchParameter.trim() : '',
                customerId: searchFlag === 'customerId' ? searchParameter.trim() : '',
                paymentReference: searchFlag === 'paymentReference' ? searchParameter.trim() : '',
                startDate: startValue ? `${moment(startValue).format(dateFormat)} ${startTime ? moment(startTime).format(timeFormat) : '00:00'}` : '',
                endDate: endValue ? `${moment(endValue).format(dateFormat)} ${endTime ? moment(endTime).format(timeFormat) : '23:59'}` : '',
                status: transactionStatus || '',
                pageNo: 1,
            },
            failAction: this.failAction
        }
        this.props.getTransactions(payload);
    }

    clearSearch() {
        this.setState({
            startValue: null,
            endValue: null,
            endOpen: false,
            searchParameter: '',
            transactionStatus: '',
            startTime: null,
            endTime: null
        })
    }


    render() {

        const { Option } = Select;
        const { startValue, endValue, endOpen, searchType, searchParameter, startTime, endTime } = this.state;
        const { loading, tableLoading } = this.props;
        console.log(this.props);
        const format = "HH:mm";

        return (
            <div>
                <Row gutter={10}>
                    <Col className="gutter-row" span={5}>
                        <Select placeholder="Search By" style={{ width: 270 }} onChange={(value) => this.handleChange(value)} defaultValue="Customer Email" >
                            <Option value="Customer Email">Customer Email</Option>
                            <Option value="Customer Id">Customer ID</Option>
                            <Option value="Transaction Reference">Transaction Reference</Option>
                            <Option value="Payment Reference">Payment Reference</Option>
                        </Select>
                    </Col>
                    <Col className="gutter-row" span={5}>
                        <Input
                            validate={searchType === 'Customer Email' ? this.validateEmail(searchParameter) : ''}
                            placeholder={searchType}
                            value={this.state.searchParameter}
                            onChange={this.onSearchParmeterChange}
                            style={{ width: 300 }}
                        />
                    </Col>

                    <Col className="gutter-row" span={3}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={startValue}
                            placeholder="Start Date"
                            onChange={this.onStartChange}
                            onOpenChange={this.handleStartOpenChange}
                        />
                        <br></br>
                        <br></br>
                        {startValue &&
                            <TimePicker placeholder="Start Time - HH:mm" style={{ width: 175 }} value={startTime} onChange={this.onStartTimeChange} format={format} />
                        }
                    </Col>

                    <Col className="gutter-row" span={3}>
                        <DatePicker
                            disabledDate={this.disabledEndDate}
                            format="DD/MM/YYYY"
                            value={endValue}
                            placeholder="End Date"
                            onChange={this.onEndChange}
                            open={endOpen}
                            onOpenChange={this.handleEndOpenChange}
                        />
                        <br></br>
                        <br></br>
                        {startValue &&
                            <TimePicker placeholder="End Time - HH:mm" style={{ width: 175 }} value={endTime} onChange={this.onEndTimeChange} format={format} />
                        }
                    </Col >
                    <Col>
                        <Col className="gutter-row" span={4}>
                            <Select placeholder="Transaction Status" style={{ width: 200 }} onChange={(value) => this.handleStatusChange(value)} value={this.state.transactionStatus ? this.state.transactionStatus : ''} >
                                <Option value="">All</Option>
                                <Option value="Pending">Pending Transaction</Option>
                                <Option value="DebitSuccessful">Successful Debit</Option>
                                <Option value="DebitFailed">Failed Debit</Option>
                                <Option value="AdviceSent">Sent SVA Call(s)</Option>
                                <Option value="AdviceFailed">Failed SVA Call(s)</Option>
                                <Option value="AdviceCompleted">Completed SVA Call(s)</Option>
                            </Select>

                        </Col>
                    </Col>

                    <Col className="gutter-row" span={4}>
                        <Button type="primary" icon="search" style={{ width: 200 }} onClick={this.onSearch} loading={loading} disabled={tableLoading}>
                            Search
                        </Button>
                        <br></br>
                        <br></br>
                        <span className="clear-search" onClick={this.clearSearch}>Clear Search Fields</span>

                    </Col>


                </Row>

            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        transactions: state.transaction,
        loading: state.loading,
        tableLoading: state.tableLoading,
        searchParam: state.searchParam,
        user: state.user
    }
}

export default connect(mapStateToProps, { getTransactions })(Search);
